import { render, staticRenderFns } from "./AdditionalSetupWizard.vue?vue&type=template&id=075bb6b6&scoped=true&"
import script from "./AdditionalSetupWizard.vue?vue&type=script&lang=js&"
export * from "./AdditionalSetupWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075bb6b6",
  null
  
)

export default component.exports